<template>
  <PageContent>
    <StepsV2 type="s3" :step="3" />
    <PanelV2
      type="w6"
      title="Upload your latest SEC Certificate"
      @nextClick="commitData"
    >
      <template v-slot:title-solt>
        <BdoProgress total="3" step="2" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="sec" @secImg="secImg" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import IdCardUpload from "./common/IdCardUpload";
  import API from "@/api";
  export default {
    name: 'PartnershipJ',
    pRouter: 'PartnershipI',
    components: {
      IdCardUpload,
    },
    data() {
      return {
        formData: { secUrl: '' }
      }
    },
    methods: {
      secImg(val){
        this.formData.secUrl = val
      },
      commitData() {
        if (this.formData.secUrl == "") {
          this.showMessageTip('The picture does not support empty ')
          return
        }
        const data = this.formatCommitData({...this.formData})
        API.addBdoProcess({
          ...data
        }).then((res) => {
          if (res.success === true) {
            this.toNext();
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>

</style>
